import { setTransactionsTickets } from "@actions";
import { connect } from "react-redux";
import BaseTab from "./BaseTab";

class TicketsTab extends BaseTab {
  fnDispatch = this.props.setTransactionsTickets;
}

const mapStateToProps = (state) => {
  return {
    data: state.transactionsTickets,
    view: state.transactionsView,
    filters: state.transactionsFilters,
  };
};

export default connect(mapStateToProps, { setTransactionsTickets })(TicketsTab);
